import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import Link from '../Link'

export default class PanoramicImageLight extends Component {
  constructor(props) {
    super(props)

    this.state = {
      scrollPosition: 0,
      triggerPosition: 0,
      triggered: false,
      scalarScroll: 0,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)

    var clientRect = ReactDOM.findDOMNode(this).getBoundingClientRect()
    this.state.triggerPosition = clientRect.top
  }

  handleScroll = () => {
    if (typeof window !== undefined) {
      var windowScrollBottom = window.pageYOffset + window.innerHeight * 0.6

      this.state.scrollPosition = windowScrollBottom

      if (
        windowScrollBottom > this.state.triggerPosition &&
        this.state.triggered == false
      ) {
        this.state.triggered = true
      }

      const scrollPercent = 50

      var scalarScroll =
        ((this.state.scrollPosition - this.state.triggerPosition) /
          window.innerHeight) *
        20
      scalarScroll = Math.min(scalarScroll, 100) // Clamp
      scalarScroll = Math.max(scalarScroll, 0)
      this.state.scalarScroll = scalarScroll

      this.setState(this.state)
    }
  }

  render() {
    var props = this.props

    var textPan = {
      top: (40 - this.state.scalarScroll) * 0.3 + '%',
    }
    var imagePan = {
      top: 0 + this.state.scalarScroll * 0.1 + '%',
    }

    var splitBullets = props.subtitle.subtitle.split('\n')
    var leftBullets = splitBullets.splice(0, Math.ceil(splitBullets.length / 2))
    var rightBullets = splitBullets

    return (
      <div className={styles.lightWrapper}>
        <div className={styles.panoramicContainer}>
          <div className="wrapper">
            <div
              className={
                styles.container +
                ' ' +
                (this.state.triggered ? styles.visible : '')
              }
            >
              <div className={styles.imageContainer} style={imagePan}>
                <GatsbyImage
                  image={props.images[0].gatsbyImageData}
                  className={styles.image}
                  imgStyle={{ objectFit: 'contain' }}
                  alt={props.images[0]?.description}
                />
              </div>

              <div className={styles.textContainer} style={textPan}>
                <h3 className={styles.title}>{props.title}</h3>
                <div className={styles.subtitle}>
                  <ul>
                    {leftBullets.map((bullet, idx) => (
                      <li key={idx}>{bullet}</li>
                    ))}
                  </ul>
                  <ul>
                    {rightBullets.map((bullet, idx) => (
                      <li key={idx}>{bullet}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  {props.components != null && props.components.length > 0 && (
                    <Link to={props.components[0].ctaUrl}>
                      {props.components[0].title}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
